import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
// import { ProposalProjectRoi } from "../Model/ProposalProjectRoi";

export async function getProposalProjectRoi(idProposalProject) {
	let response = await getAPIResponse("/v1/proposal-project-roi/"+idProposalProject);
	if (response === null) {
		return null;
	}
	return response;
}
